<template>
    <a @click.prevent="mark" @keyup.enter.prevent="mark" class="favorite-button" :title="translate('merklistAdd')" tabindex="0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.8 26.3">
        <title>{{ translate('merklistAdd') }}</title>
        <path class="favorite-active" :class="{ 'favorite-active--on': marked }" fill="#FFED00" d="M21.2 3.7C18 3 14.9 5 14.2 8.2c0 .1-.1.4-.1.6-.4-3.4-3.4-5.6-6.7-5.2-.1 0-.3 0-.4.1-5.3.8-5.7 7.5-2.8 11.7.3.4 6.4 7 8.9 9.6l1.1 1.3 1.1-1.1c2.5-2.8 8.5-9.2 8.8-9.8 2.8-4.2 2.4-10.9-2.9-11.7"/>
        <path fill="#5B5B5B" d="M12.8 24.9c-.3 0-.4-.1-.6-.3l-1.1-1.3c-.6-.6-1.3-1.4-2.2-2.4-4.7-5-6.7-7.3-7-7.7C0 10.6-.6 7 .7 3.8 1.5 1.8 3.4.4 5.4.2c1.8-.4 3.8 0 5.3 1.1.8.6 1.5 1.4 2 2.4.4-1 1.1-1.8 2.1-2.4 1.5-1.1 3.5-1.4 5.3-1C22.2.6 24 2 24.8 3.9c1.1 3.2.7 6.8-1.3 9.5-.1.3-1.5 1.8-5.3 6-1.4 1.5-2.8 3.1-3.6 4.1l-1.1 1.1c-.3.1-.5.3-.7.3zm-6-23.2c-.4 0-.8 0-1.3.1C4 2 2.8 3.1 2.1 4.5c-1 2.8-.4 5.7 1.3 8.1.2.4 4.3 4.9 6.6 7.4.8 1 1.7 1.7 2.2 2.4l.6.6.6-.6c.8-1 2.2-2.5 3.6-4.1 2.2-2.4 5-5.4 5.2-5.9 1.7-2.4 2.1-5.3 1.1-8.1-.6-1.5-2-2.5-3.6-2.7-1.4-.3-2.9 0-4.2.8-1.1 1-2 2.2-2.2 3.6 0 .4-.4.7-.8.7s-.7-.3-.8-.7c0-1.4-.7-2.7-1.8-3.6-1-.4-2-.8-3.1-.7z"/>
      </svg>
    </a>
</template>
<script>
    import translationMixin from '@/mixins/translation'
    export default {
      name: 'Favorite',
      props: {
        activity_id: Number,
        classes: {
          type: String,
          default: 'icon-heart',
        },
      },
      mixins: [translationMixin],
      computed: {
        marked: function () {
          return this.getFavorite(this.activity_id) !== undefined
        },
      },
      methods: {
        getFavorite(favoriteId){
          return this.$store.getters.getFavorite(favoriteId)
        },

        mark () {
          const favorite = this.getFavorite(this.activity_id)
          if (favorite) {
            this.$store.dispatch('deleteFavorite', {
              id: parseInt(favorite.id, 10),
              })
              } else {
                this.$store.dispatch('addFavorite', {
                  activity: parseInt(this.activity_id, 10),
                  })
              }
            },
        },
    }
</script>
